<div class="flex flex-col gap-6">
  <!-- E-Mail Settings Card -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="px-4 pt-4">
        <h3 class="text-lg font-semibold m-0">E-Mail verwalten</h3>
        <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">Ändere hier deine aktuelle E-Mail Adresse</p>
      </div>
    </ng-template>
    <div class="flex flex-col gap-4">
      <zaeper-input-group [inputOptions]="emailInputGroup"/>
      <div class="flex justify-start">
        <p-button [rounded]="true">E-Mail ändern</p-button>
      </div>
    </div>
  </p-card>

  <!-- Password Settings Card -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="px-4 pt-4">
        <h3 class="text-lg font-semibold m-0">Passwort zurücksetzen</h3>
        <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">Sende eine Anfrage zum Zurücksetzen des Passworts per E-Mail</p>
      </div>
    </ng-template>
    <div class="flex justify-start">
      <p-button [rounded]="true" (onClick)="sendEmailPasswordRequest()">Anfrage senden</p-button>
    </div>
  </p-card>

  <!-- Appearance Settings Card -->
  <p-card>
    <ng-template pTemplate="header">
      <div class="px-4 pt-4">
        <h3 class="text-lg font-semibold m-0">Darstellung</h3>
        <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">Wähle dein bevorzugtes Farbschema</p>
      </div>
    </ng-template>
    <div class="flex flex-col gap-4">
      <p-select
        [options]="colorSchemeOptions"
        [(ngModel)]="selectedColorScheme"
        (ngModelChange)="onColorSchemeChange($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="Farbschema wählen"
        class="w-full max-w-xs">
      </p-select>
    </div>
  </p-card>

  <!-- Danger Zone Card -->
  <p-card styleClass="border-red-200 border-2">
    <ng-template pTemplate="header">
      <div class="px-4 pt-4">
        <div class="flex items-center gap-2">
          <i class="pi pi-exclamation-triangle text-red-500"></i>
          <h3 class="text-lg font-semibold m-0 text-red-600">Gefahrenzone</h3>
        </div>
        <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">Irreversible und destruktive Aktionen</p>
      </div>
    </ng-template>
    <div class="flex flex-col gap-4">
      <div class="flex items-center justify-between p-4 border border-red-200 rounded-lg bg-red-50">
        <div>
          <h4 class="font-medium text-red-700 m-0">Konto löschen</h4>
          <p class="text-sm text-red-600 mt-1">Sobald du dein Konto löschst, gibt es kein Zurück mehr. Bitte sei dir sicher.</p>
        </div>
        <p-button 
          [rounded]="true" 
          severity="danger"
          [outlined]="true"
          (onClick)="sendDeleteAccountRequest()">
          Konto löschen
        </p-button>
      </div>
    </div>
  </p-card>
</div>
